import { LobbyScene } from "./../LobbyScene";
import { GameVars } from "./../../../GameVars";
import { GameManager } from "../../../GameManager";
import { AudioManager } from "../../../AudioManager";
import { MapProgress } from "../../../../types/tower-defense";

export class MapButton extends Phaser.GameObjects.Container {

    private map: MapProgress;
    private zone: number;
    private index: number;
    private stars: Phaser.GameObjects.Image;
    private playBtn: Phaser.GameObjects.Image;

    constructor(scene: Phaser.Scene, x: number, y: number, map: MapProgress, zone: number, index: number) {

        super(scene);

        this.x = x;
        this.y = y;

        this.map = map;
        this.zone = zone;
        this.index = index;

        this.playBtn = new Phaser.GameObjects.Image(this.scene, 0, 20, "texture_atlas_1", "btn_stage_" + (this.zone + 1) + "_playable_idle");
        this.playBtn.setInteractive();
        this.playBtn.setOrigin(.5, 1);
        this.playBtn.on("pointerdown", function () {
            if (GameVars.gameData.buyTutorial && !GameVars.gameData.initialTutorial) {
                return;
            }

            if (typeof window.GameSnacks !== "undefined") {

                window.GameSnacks.ad.break({
                    type: "next",
                    afterAd: () => {
                    },
                    beforeAd: () => {
                        AudioManager.muteSound();
                        AudioManager.muteSoundtrack();
                    },
                    adBreakDone: (placementInfo: any) => {
                        if (!GameVars.gameData.soundMuted) {
                            AudioManager.unMuteSound();
                        }
                        if (!GameVars.gameData.soundtrackMuted) {
                            AudioManager.unMuteSoundtrack();
                        }
                        this.playBtn.setFrame("btn_stage_" + (this.zone + 1) + "_playable_pressed");
                        AudioManager.playSound("btn_click");
                    },
                });
            } else {
                this.playBtn.setFrame("btn_stage_" + (this.zone + 1) + "_playable_pressed");
                AudioManager.playSound("btn_click");
            }
        }, this);
        this.playBtn.on("pointerup", function () {
            this.onClickMap();
        }, this);
        this.playBtn.on("pointerout", function () {
            if (GameVars.gameData.buyTutorial && !GameVars.gameData.initialTutorial) {
                return;
            }
            this.playBtn.setFrame("btn_stage_" + (this.zone + 1) + "_playable_idle");
        }, this);

        this.playBtn.on("pointerover", function () {
            if (GameVars.gameData.buyTutorial && !GameVars.gameData.initialTutorial) {
                return;
            }
            this.playBtn.setFrame("btn_stage_" + (this.zone + 1) + "_playable_over");
        }, this);
        this.add(this.playBtn);

        if (!this.map.unlocked) {
            this.playBtn.setFrame("stage_locked");
            this.playBtn.input.enabled = false;
        } else {
            this.stars = new Phaser.GameObjects.Image(this.scene, 0, -45, "texture_atlas_1", "ui_stars_" + this.map.stars);
            this.add(this.stars);

            if (this.map.stars === 0) {
                this.stars.visible = false;
            }
        }

        if (this.zone === 0 && this.index === 0 && GameVars.gameData.initialTutorial) {

            const tutorialHand = new Phaser.GameObjects.Image(this.scene, 0, -90, "texture_atlas_1", "hand-cursor");
            tutorialHand.setScale(-1);
            this.add(tutorialHand);

            this.scene.tweens.add({
                targets: tutorialHand,
                y: tutorialHand.y + 10,
                ease: Phaser.Math.Easing.Cubic.Out,
                duration: 500,
                repeat: -1,
                yoyo: true
            });
        }
    }

    public showLevelCompleted(): void {

        this.stars.setFrame("ui_stars_" + GameVars.levelCompleted.prevStars);

        this.scene.time.addEvent({
            delay: 1500, callback: () => {
                AudioManager.playSound("star_appears");
                this.stars.setFrame("ui_stars_" + this.map.stars);
                LobbyScene.currentInstance.addHUDStar(this.x, this.y - 45, this.map.stars - GameVars.levelCompleted.prevStars);
            }, callbackScope: this
        });
    }

    public unlockNextLevel(): void {

        this.playBtn.setFrame("stage_locked");
        this.playBtn.input.enabled = false;
        this.stars.visible = false;

        let delay = GameVars.levelCompleted.map === 5 && GameVars.levelCompleted.zone !== 4 ? 3000 : 2000;

        this.scene.time.addEvent({
            delay: delay, callback: () => {

                let flare = new Phaser.GameObjects.Image(this.scene, 0, -20, "texture_atlas_1", "flare_blue");
                flare.alpha = 0;
                flare.setScale(0);
                flare.blendMode = Phaser.BlendModes.OVERLAY;
                this.add(flare);

                AudioManager.playSound("new_level_unlocked");

                this.scene.tweens.add({
                    targets: flare,
                    alpha: 1,
                    scaleX: 2,
                    scaleY: 2,
                    ease: Phaser.Math.Easing.Linear,
                    duration: 100,
                    onComplete: () => {

                        this.playBtn.input.enabled = true;
                        this.playBtn.setFrame("btn_stage_" + (this.zone + 1) + "_playable_idle");

                        this.scene.tweens.add({
                            targets: flare,
                            alpha: 0,
                            scaleX: 3,
                            scaleY: 3,
                            ease: Phaser.Math.Easing.Linear,
                            duration: 100,
                            onComplete: () => {
                                flare.destroy();
                            },
                            onCompleteScope: this
                        });
                    },
                    onCompleteScope: this
                });
            }, callbackScope: this
        });
    }

    private onClickMap(): void {

        if (GameVars.gameData.buyTutorial && !GameVars.gameData.initialTutorial) {
            return;
        }

        if (GameVars.gameData.buyTutorial && !GameVars.gameData.initialTutorial) {
            return;
        }

        GameVars.usePrevTurrets = false;

        GameManager.enterBattleScene(this.map.mapName, this.zone, this.index);
    }
}
